import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HIDE_ON = ["/start", "/admin", "/thank-you"];

export default function StickyMobileCTA() {
  const location = useLocation();
  if (HIDE_ON.some((p) => location.pathname.startsWith(p))) return null;
  if (location.pathname === "/sell") return null; // hide on the page itself

  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-black/95 backdrop-blur border-t border-white/10 px-4 py-3"
      data-testid="sticky-mobile-cta"
    >
      <Link
        to="/sell"
        className="btn-gold w-full flex items-center justify-center gap-2 py-3.5 font-semibold text-sm tracking-wide"
      >
        Sell Your Property <ArrowRight size={16} />
      </Link>
    </div>
  );
}
